import StateManager from "Apollo/StateManager";

const stateManager = new StateManager('showroom.userView.samples');

export const setIsRequestSamplesFormOpen = (isRequestSamplesFormOpen: boolean) => {
	stateManager.update({ isRequestSamplesFormOpen });
};

export const setIsRequestSamplesValid = (isRequestSamplesFormValid: boolean) => {
	stateManager.update({ isRequestSamplesFormValid });
};
